import { RenderDetailViewProps } from 'interfaces/model.interface'

import { CardioCandidateData } from 'config/common/baseModel/cardio360/Cardio360Candidate'

import Detail from './Detail'

const Candidates = ({
  model,
  data,
  setSelectedRow,
  viewData,
}: RenderDetailViewProps<Record<CardioCandidateData, string>>) => {
  if (!data) {
    return null
  }
  return (
    <Detail
      model={model}
      title='candidateName'
      candidate={data}
      handleClose={() => setSelectedRow(null)}
      viewData={viewData}
    />
  )
}

export default Candidates
